"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WRAPPED_COLUMNS_DISPLAY_TYPES = exports.VIEWPORT_SIZES = exports.UNICODE_NORMALIZATION_FORMS = exports.TREE_SELECTION_TYPES = exports.TREE_NODE_HIGHLIGHTS = exports.TOOLBAR_STYLES = exports.TOAST_PLACEMENTS = exports.TEXT_TAGS = exports.TEXT_ALIGN_TYPES = exports.STRING_MATCHER_METHODS = exports.STATEFUL_MESSAGE_TYPES = exports.SPINNER_TYPES = exports.SPINNER_SIZES = exports.SECTION_ALIGNMENTS = exports.RELATIVE_PLACEMENTS = exports.PROGRESS_INDICATOR_TYPES = exports.PROCESS_FLOW_STEP_TYPES = exports.POPPER_WIDTH_SIZING = exports.POPPER_PLACEMENTS = exports.POPOVER_TYPES = exports.PANEL_STYLES = exports.ORIENTATION_TYPES = exports.OBJECT_DISPLAY_TYPES = exports.OBJECT_DISPLAY_STYLES = exports.OBJECT_DISPLAY_SIZES = exports.NATIVE_HTML_BUTTON_TYPES = exports.MULTICOMBOBOX_SELECTION_TYPES = exports.MODAL_SIZES = exports.MESSAGEBOX_TYPES = exports.MESSAGEBOX_BUTTON_SIZES = exports.MANUAL_BEHAVIOR_TYPES = exports.LIST_TYPES = exports.LISTBOX_SELECTION_TYPES = exports.LAYOUT_TYPES = exports.ILLUSTRATION_TYPES = exports.ILLUSTRATION_SIZES = exports.ICON_SIZES = exports.GRIDLIST_ITEM_TYPES = exports.FORM_GROUP_TOOLTIP_ICON_SIZE_MAP = exports.FORM_CONTROL_VALIDATION_STATES = exports.FORM_CONTROL_TYPES = exports.FILTER_TYPES = exports.DATA_GRID_SHOW_BULK_HELPER = exports.DATA_GRID_SELECTION_TYPE = exports.DATA_GRID_BULK_MODE = exports.CSS_PREFIX = exports.CONTROL_SIZES = exports.COMBOBOX_SELECTION_TYPES = exports.COLUMN_IMPORTANCE_TYPES = exports.COLUMN_HEADER_BACKGROUND_TYPES = exports.CHECKBOX_STATES = exports.BUTTON_TYPES = exports.AVATAR_SIZES = void 0;
var TEXT_ALIGN_TYPES = ['left', 'right', 'center'];
exports.TEXT_ALIGN_TYPES = TEXT_ALIGN_TYPES;
var COMBOBOX_SELECTION_TYPES = ['manual', 'auto', 'auto-inline'];
exports.COMBOBOX_SELECTION_TYPES = COMBOBOX_SELECTION_TYPES;
var MULTICOMBOBOX_SELECTION_TYPES = ['manual', 'type-ahead'];
exports.MULTICOMBOBOX_SELECTION_TYPES = MULTICOMBOBOX_SELECTION_TYPES;
var STRING_MATCHER_METHODS = ['startsWith', 'includes'];
exports.STRING_MATCHER_METHODS = STRING_MATCHER_METHODS;
var CONTROL_SIZES = ['lg', 'md'];
exports.CONTROL_SIZES = CONTROL_SIZES;
var DATA_GRID_SELECTION_TYPE = ['single', 'single-radio', 'multi'];
exports.DATA_GRID_SELECTION_TYPE = DATA_GRID_SELECTION_TYPE;
var DATA_GRID_SHOW_BULK_HELPER = ['whileSelecting', 'whileSelectingAndClearing'];
exports.DATA_GRID_SHOW_BULK_HELPER = DATA_GRID_SHOW_BULK_HELPER;
var DATA_GRID_BULK_MODE = ['all', 'current'];
exports.DATA_GRID_BULK_MODE = DATA_GRID_BULK_MODE;
var MESSAGEBOX_BUTTON_SIZES = ['lg', 'md'];
exports.MESSAGEBOX_BUTTON_SIZES = MESSAGEBOX_BUTTON_SIZES;
var MODAL_SIZES = ['lg', 'md', 'sm', 'xl'];
exports.MODAL_SIZES = MODAL_SIZES;
var ICON_SIZES = ['xl', 'xl-minus', 'lg-plus', 'lg', 'lg-minus', 'md-plus', 'md', 'md-minus', 'sm-plus', 'sm', 'sm-minus', 'xs-plus', 'xs'];
exports.ICON_SIZES = ICON_SIZES;
var AVATAR_SIZES = ['xl', 'lg', 'md', 'sm', 'xs'];
exports.AVATAR_SIZES = AVATAR_SIZES;
var VIEWPORT_SIZES = ['lg', 'md', 'sm', 'xs'];
exports.VIEWPORT_SIZES = VIEWPORT_SIZES;
var MESSAGEBOX_TYPES = ['confirm', 'error', 'info', 'success', 'warning'];
exports.MESSAGEBOX_TYPES = MESSAGEBOX_TYPES;
var STATEFUL_MESSAGE_TYPES = ['error', 'info', 'success', 'warning', 'custom'];
exports.STATEFUL_MESSAGE_TYPES = STATEFUL_MESSAGE_TYPES;
var GRIDLIST_ITEM_TYPES = ['error', 'info', 'success', 'warning', 'create'];
exports.GRIDLIST_ITEM_TYPES = GRIDLIST_ITEM_TYPES;
var BUTTON_TYPES = ['default', 'primary', 'secondary', 'success', 'info', 'warning', 'danger', 'link', 'create'];
exports.BUTTON_TYPES = BUTTON_TYPES;
var NATIVE_HTML_BUTTON_TYPES = ['button', 'reset', 'submit'];
exports.NATIVE_HTML_BUTTON_TYPES = NATIVE_HTML_BUTTON_TYPES;
var POPOVER_TYPES = ['success', 'info', 'warning', 'error'];
exports.POPOVER_TYPES = POPOVER_TYPES;
var FORM_CONTROL_TYPES = ['number', 'password', 'text'];
exports.FORM_CONTROL_TYPES = FORM_CONTROL_TYPES;
var FORM_CONTROL_VALIDATION_STATES = ['error', 'warning'];
exports.FORM_CONTROL_VALIDATION_STATES = FORM_CONTROL_VALIDATION_STATES;
var FORM_GROUP_TOOLTIP_ICON_SIZE_MAP = {
  lg: 'sm-minus',
  md: 'xs-plus'
};
exports.FORM_GROUP_TOOLTIP_ICON_SIZE_MAP = FORM_GROUP_TOOLTIP_ICON_SIZE_MAP;
var POPPER_PLACEMENTS = ['auto-start', 'auto', 'auto-end', 'bottom-start', 'bottom', 'bottom-end', 'left-start', 'left', 'left-end', 'right-start', 'right', 'right-end', 'top-start', 'top', 'top-end'];
exports.POPPER_PLACEMENTS = POPPER_PLACEMENTS;
var POPPER_WIDTH_SIZING = ['none', 'matchTarget', 'minTarget', 'maxTarget'];

// Allowable horizontal alignments for <Section> widgets:
exports.POPPER_WIDTH_SIZING = POPPER_WIDTH_SIZING;
var SECTION_ALIGNMENTS = ['left', 'right'];
exports.SECTION_ALIGNMENTS = SECTION_ALIGNMENTS;
var PANEL_STYLES = ['basic', 'default', 'primary'];
exports.PANEL_STYLES = PANEL_STYLES;
var SPINNER_SIZES = ['lg', 'md', 'sm'];
exports.SPINNER_SIZES = SPINNER_SIZES;
var SPINNER_TYPES = ['block', 'fullScreen', 'fullPage', 'inline'];
exports.SPINNER_TYPES = SPINNER_TYPES;
var CSS_PREFIX = 'sapcnqr';
exports.CSS_PREFIX = CSS_PREFIX;
var TREE_SELECTION_TYPES = ['single', 'multi', 'singleSelectMaster'];
exports.TREE_SELECTION_TYPES = TREE_SELECTION_TYPES;
var TREE_NODE_HIGHLIGHTS = ['info', 'error', 'success', 'warning'];
exports.TREE_NODE_HIGHLIGHTS = TREE_NODE_HIGHLIGHTS;
var OBJECT_DISPLAY_TYPES = ['error', 'warning', 'success', 'info', 'neutral'];
exports.OBJECT_DISPLAY_TYPES = OBJECT_DISPLAY_TYPES;
var PROCESS_FLOW_STEP_TYPES = ['error', 'warning', 'success', 'info', 'neutral', 'completed', 'current', 'future'];
exports.PROCESS_FLOW_STEP_TYPES = PROCESS_FLOW_STEP_TYPES;
var OBJECT_DISPLAY_SIZES = ['default', 'lg'];
exports.OBJECT_DISPLAY_SIZES = OBJECT_DISPLAY_SIZES;
var OBJECT_DISPLAY_STYLES = ['default', 'inverted', 'outlined', 'shaded'];
exports.OBJECT_DISPLAY_STYLES = OBJECT_DISPLAY_STYLES;
var TOOLBAR_STYLES = ['solid', 'transparent'];
exports.TOOLBAR_STYLES = TOOLBAR_STYLES;
var WRAPPED_COLUMNS_DISPLAY_TYPES = ['block', 'grid-small', 'grid-large'];
exports.WRAPPED_COLUMNS_DISPLAY_TYPES = WRAPPED_COLUMNS_DISPLAY_TYPES;
var COLUMN_IMPORTANCE_TYPES = ['low', 'medium', 'high'];
exports.COLUMN_IMPORTANCE_TYPES = COLUMN_IMPORTANCE_TYPES;
var MANUAL_BEHAVIOR_TYPES = ['wrap', 'hide'];
exports.MANUAL_BEHAVIOR_TYPES = MANUAL_BEHAVIOR_TYPES;
var FILTER_TYPES = ['manual', 'auto'];
exports.FILTER_TYPES = FILTER_TYPES;
var ILLUSTRATION_TYPES = ['SceneSimpleEmptyList', 'SceneSimpleMagnifier', 'SceneSimpleNotFoundMagnifier', 'SceneSimpleTask', 'SceneSimpleBell', 'SceneSimpleMail', 'SceneSimpleEmptyDoc', 'SceneSimpleCalendar', 'SceneSimpleNoSavedItems', 'SceneSimpleReload', 'SceneSimpleError', 'SceneSimpleConnection', 'SceneSimpleBalloon', 'SceneSimpleCheckmark', 'DialogIllustratedFaceID'];
exports.ILLUSTRATION_TYPES = ILLUSTRATION_TYPES;
var ILLUSTRATION_SIZES = ['lg',
// scene
'md',
// dialog
'sm' // spot
];
exports.ILLUSTRATION_SIZES = ILLUSTRATION_SIZES;
var TEXT_TAGS = ['span', 'p', 'b', 'strong', 'i', 'em', 'pre', 'code', 'div'];
exports.TEXT_TAGS = TEXT_TAGS;
var LIST_TYPES = ['ordered', 'unordered'];
exports.LIST_TYPES = LIST_TYPES;
var LISTBOX_SELECTION_TYPES = ['singleSelectMaster',
// used to pick one item with no additional indicator
'singleSelectLeft',
// used to pick one item using a radio button
'multiSelect' // used to pick several items from the list using checkboxes on the far left
];
exports.LISTBOX_SELECTION_TYPES = LISTBOX_SELECTION_TYPES;
var COLUMN_HEADER_BACKGROUND_TYPES = ['default', 'panel'];
exports.COLUMN_HEADER_BACKGROUND_TYPES = COLUMN_HEADER_BACKGROUND_TYPES;
var CHECKBOX_STATES = ['unselected', 'selected', 'indeterminate'];
exports.CHECKBOX_STATES = CHECKBOX_STATES;
var TOAST_PLACEMENTS = ['bottom-center', 'bottom-end', 'bottom-start', 'middle-center', 'middle-end', 'middle-start', 'top-center', 'top-end', 'top-start'];
exports.TOAST_PLACEMENTS = TOAST_PLACEMENTS;
var RELATIVE_PLACEMENTS = ['top-end', 'top-start', 'bottom-end', 'bottom-start'];
exports.RELATIVE_PLACEMENTS = RELATIVE_PLACEMENTS;
var PROGRESS_INDICATOR_TYPES = ['success', 'info', 'warning', 'error'];
exports.PROGRESS_INDICATOR_TYPES = PROGRESS_INDICATOR_TYPES;
var LAYOUT_TYPES = ['horizontal', 'vertical'];
exports.LAYOUT_TYPES = LAYOUT_TYPES;
var ORIENTATION_TYPES = ['horizontal', 'vertical'];
exports.ORIENTATION_TYPES = ORIENTATION_TYPES;
var UNICODE_NORMALIZATION_FORMS = ['NFD', 'NFC', 'NFKD', 'NFKC'];
exports.UNICODE_NORMALIZATION_FORMS = UNICODE_NORMALIZATION_FORMS;